module.exports = __webpack_public_path__ + "static/media/Picture68.f212b52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture68.png
// module id = 1555
// module chunks = 0